export default "__VITE_ASSET__BFM1HA33__"